import React from 'react';
import qs from 'qs';
import callApi from '../../utils/callApi';
import { capitalizeFirstChar } from '../../utils/helpers';

import {
    ARHIVE_LIST,
    ARHIVE_LIST_BY_SEGMENT,
    ARHIVE_LIST_BY_ANCHOR,
    ARHIVE_LIST_BY_VINTAGE,
    ARHIVE_LIST_BY_DATE,
    SEGMENTS_LIST,
    ANCHOR_LIST,
    VINTAGE_LIST,
    ARHIVE_LIST_BY_TEXT
} from '../../constants/apiUrls/apiUrls';
import { MONTHS } from '../../constants/dateConstants';

import ArchivesFilters from './ArchivesFilters/ArchivesFilters';
import ArchivesList from './ArchivesList/ArchivesList';
import Pagination from '../../components/arhiveComponents/Pagination';
import ArchivesVideoPlayer from './ArchivesVideoPlayer/ArchivesVideoPlayer';

import { parseSlug } from './archives-utils/archivesUtils';

import './css/Archives.css';

class Archives extends React.Component {

    state = {
        typeOfListing: 'all',
        arhives: [],
        isLoading: false,
        showVideo: false,
        showSegmentList: false,
        videoElement: null,
        listingId: null,
        listingYear: null,
        listingMonth: null,
        listingTitle: null,
        currentPageNumber: 1,
        totalNumberOfEntries: null,
        entriesPerPage: 36,
        vintageSlugPrefix: '',
        programSegmentId: '',
        searchSegmentId: null,
        searchAnchorId: null,
        searchFullText: null,
        segments: [],
        anchors: [],
        vintage: []
    };

    saveStateKey = (key, value) => {
        this.setState({ [key]: value }, () => this.fetchArhives());
    };

    setTypeOfListing = (type, id, title) => {
        const { typeOfListing, listingId } = this.state;

        if (type !== typeOfListing || listingId !== id) {
            this.setState(
                {
                    typeOfListing: type,
                    listingId: id,
                    listingYear: null,
                    listingMonth: null,
                    listingTitle: title,
                    showVideo: false,
                    showSegmentList: false,
                    isLoading: true,
                    videoElement: null
                },
                () => this.fetchArhives()
            );
        }
    };

    setTypeOfListingForDate = (type, year, month) => {
        const { typeOfListing, listingYear, listingMonth } = this.state;

        const parsedListingTitle = `${MONTHS[month * 1 - 1].name} ${year}`;
        if (
            type !== typeOfListing ||
            year !== listingYear ||
            month !== listingMonth
        ) {
            this.setState(
                {
                    typeOfListing: type,
                    listingId: null,
                    listingYear: year,
                    listingMonth: month,
                    listingTitle: parsedListingTitle,
                    showVideo: false,
                    showSegmentList: false,
                    videoElement: null
                },
                () => this.fetchArhives()
            );
        }
    };

    componentDidUpdate() {
        window.scrollTo(0, 0);
    }

    getIdFromUrl = () => {
        const { location } = this.props;
        const parsedSearch = qs.parse(location.search, {
            ignoreQueryPrefix: true
        });
        return parsedSearch.segmentid || parsedSearch.anchorid;
    };

    fetchArhives = () => {
        const url = this.decideUrl();
        this.fetchArhiveListByTypeOfListing(url);
    };

    fetchArhivesFromLocation = () => {
        const { location, history, slug, match } = this.props;
        const {
            entriesPerPage,
            currentPageNumber,
            listingMonth,
            programSegmentId,
            anchors
        } = this.state;

        if (location.search || (match && match.params.slug)) {
            let anchor = {};
            if (match && match.params && match.params.slug) {
                anchor = anchors.guestAnchors.find(anch => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
                            anchors.pastAnchors.find(anch => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
                            anchors.currentAnchors.find(anch => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase());
            }
            const id = this.getIdFromUrl() || anchor.id;
            let baseUrl = ARHIVE_LIST_BY_SEGMENT;
            const searchByAnchor = location.search.includes('anchorid') || !!anchor.id;
            if (searchByAnchor) {
                baseUrl = ARHIVE_LIST_BY_ANCHOR;
            }

            let parsedUrl = baseUrl
                .replace('{page}', currentPageNumber - 1)
                .replace('{size}', encodeURIComponent(entriesPerPage))
                .replace('{id}', encodeURIComponent(id))
                .replace('{month}', encodeURIComponent(listingMonth));
            callApi(parsedUrl, 'get', {}).then(res => {
                if (res.data.segments) {
                    if (!slug && baseUrl === ARHIVE_LIST_BY_SEGMENT && id === '219') {
                        history.replace(parseSlug(res.data.segments[0], 'segment', id));
                        return;
                    }
                    const videoElement = anchor.id ? res.data.segments[0] : this.getVideoElementById(
                        res.data.segments
                    );

                    if (anchor.id) {
                        this.setState({showVideo: true});
                    }

                    this.setState({
                        arhives: res.data.segments,
                        isLoading: false,
                        totalNumberOfEntries: res.data.count
                            ? res.data.count
                            : entriesPerPage,
                        videoElement: videoElement || { programSegmentId },
                        showSegmentList: true,
                        listingId: id,
                        typeOfListing: searchByAnchor ? 'anchor' : 'segment',
                        searchAnchorId: searchByAnchor && id,
                        searchSegmentId:
                            location.search.includes('segmentid') && id
                    });
                }
            });
        }
    };
    decideUrl = () => {
        const { typeOfListing } = this.state;
        let url = '';

        switch (typeOfListing) {
            case 'segment':
                url = ARHIVE_LIST_BY_SEGMENT;
                break;
            case 'anchor':
                url = ARHIVE_LIST_BY_ANCHOR;
                break;
            case 'date':
                url = ARHIVE_LIST_BY_DATE;
                break;
            case 'vintage':
                url = ARHIVE_LIST_BY_VINTAGE;
                break;
            case 'search': 
                url = ARHIVE_LIST_BY_TEXT;
                break;
            default:
                url = ARHIVE_LIST;
                break;
        }

        return url;
    };

    getVideoElementById = data => {
        const { location } = this.props;
        const regex = /-w\d{1,}/;
        const found = location.pathname.match(regex);
        const videoId = found && found[0].replace('-w', '');
        const videoElement = data.filter(
            (segment, index) => segment.programSegmentId == parseInt(videoId)
        );

        return videoElement[0];
    };

    fetchArhiveListByTypeOfListing = url => {
        const {
            entriesPerPage,
            currentPageNumber,
            listingId,
            listingMonth,
            listingYear,
            typeOfListing,
            programSegmentId
        } = this.state;
        const { slug, location } = this.props;
        const parsedSearch = qs.parse(location.search, {
            ignoreQueryPrefix: true
        });
        const idReplace = listingId ? listingId : listingYear;

        let parsedUrl = url
            .replace('{page}', currentPageNumber - 1)
            .replace('{size}', encodeURIComponent(entriesPerPage))
            .replace('{id}', encodeURIComponent(idReplace))
            .replace('{month}', encodeURIComponent(listingMonth))
            .replace('{searchParam}', encodeURIComponent(parsedSearch.search));

        callApi(parsedUrl, 'get', {}).then(res => {
            if (res.data.segments) {
                // send video element only with program segment id
                // this is used in case when user come from anchors page
                const videoElement = ['all', 'search'].includes(typeOfListing) && {
                    programSegmentId
                };
                const slugSplit = slug ? slug.split('/') : [];
                const id =
                    slugSplit && slugSplit[1] && slugSplit[1].match(/\d+/)[0];
                this.setState({
                    arhives: res.data.segments,
                    videoElement: videoElement ||
                        res.data.segments.find(seg => {
                            if (typeOfListing === 'vintage') {
                                return slug.includes(seg.slug);
                            }
                            return seg.programSlug === slug;
                        }) || { id },
                    isLoading: false,
                    searchFullText: parsedSearch.search,
                    totalNumberOfEntries: res.data.count
                        ? res.data.count
                        : entriesPerPage
                });
            } else {
                this.setState({
                    arhives: res.data,
                    isLoading: false,
                    searchFullText: parsedSearch.search,
                    totalNumberOfEntries: res.data.count
                        ? res.data.count
                        : entriesPerPage
                });
            }
        });
    };

    componentDidMount() {
        let defaultTitle = "Archives | Naked News"
        document.title = this.props.slug ? `${capitalizeFirstChar(this.props.slug)} | ${defaultTitle}` : defaultTitle
        Promise.all([
            callApi(SEGMENTS_LIST, 'get', {}),
            callApi(ANCHOR_LIST, 'get', {}),
            callApi(VINTAGE_LIST, 'get', {})
        ])
            .then(([segments, anchors, vintage]) => {
                this.setState(
                    {
                        segments: segments.data,
                        anchors: anchors.data,
                        vintage: vintage.data
                    },
                    () => {
                        const { location, slug, match } = this.props;
                        const parsedSearch = qs.parse(location.search, {
                            ignoreQueryPrefix: true
                        });
                        if (location.search || (match && match.params.slug)) {
                            let selectedSegment;
                            let anchor = {};
                            if (match && match.params && match.params.slug) {
                                anchor = this.state.anchors.guestAnchors.find(anch => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
                                            this.state.anchors.pastAnchors.find(anch => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
                                            this.state.anchors.currentAnchors.find(anch => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase());
                            }
                            if (!parsedSearch.anchorid && !parsedSearch.segmentid && !anchor) {
                                this.props.history.push('/not-found');
                                return;
                            }
                            const anchorid = parsedSearch.anchorid || anchor.id;
                            if (parsedSearch.segmentid) {
                                selectedSegment = this.state.segments.find(
                                    segment =>
                                        segment.id ===
                                        parseInt(parsedSearch.segmentid)
                                );
                            }
                            if (anchorid) {
                                selectedSegment = Object.keys(
                                    this.state.anchors
                                ).reduce((seg, anchorsListName) => {
                                    if (seg.name) return seg;
                                    return (
                                        this.state.anchors[
                                            anchorsListName
                                        ].find(
                                            anc =>
                                                anc.id ===
                                                parseInt(anchorid)
                                        ) || {}
                                    );
                                }, {});
                            }
                            this.setState(
                                {
                                    currentPageNumber: parsedSearch.page || 1,
                                    listingTitle: selectedSegment
                                        ? selectedSegment.name
                                        : ''
                                },
                                () => {
                                    if (
                                        parsedSearch.segmentid || anchorid
                                    ) {
                                        this.fetchArhivesFromLocation();
                                    } else {
                                        this.fetchArhives();
                                    }
                                }
                            );
                        }
                        if (slug) {
                            const slugSplit = slug ? slug.split('/') : [];
                            if (slug.match(/(-v(\d){2,10})/)) {
                                const listingId = slug
                                    .match(/-v(\d){2,10}/)[0]
                                    .replace('-v', '');
                                const selectedVintage = this.state.vintage.find(
                                    vintage =>
                                        vintage.id === parseInt(listingId)
                                );
                                this.setState(
                                    {
                                        typeOfListing: 'vintage',
                                        showVideo: !!slugSplit[1],
                                        showSegmentList: true,
                                        listingId,
                                        listingTitle: selectedVintage.name,
                                        vintageSlugPrefix: slugSplit[0]
                                    },
                                    () =>
                                        !location.search && this.fetchArhives()
                                );
                            } else if (slug.match(/-w\d{2,10}/)) {
                                const programSegmentId = slug
                                    .match(/-w\d{2,10}/)[0]
                                    .replace('-w', '');
                                this.setState(
                                    {
                                        typeOfListing: 'all',
                                        showVideo: true,
                                        showSegmentList: true,
                                        programSegmentId
                                    },
                                    () =>
                                        parsedSearch.anchorid ||
                                        parsedSearch.segmentid
                                            ? false
                                            : this.fetchArhives()
                                );
                            } else {
                                const currentMonth = MONTHS.find(
                                    month => month.number === slugSplit[1]
                                );
                                this.setState(
                                    {
                                        typeOfListing: 'date',
                                        listingYear: slugSplit[0],
                                        listingMonth: slugSplit[1],
                                        listingTitle: `${currentMonth.name} ${
                                            slugSplit[0]
                                        }`,
                                        showVideo: /nude-program/.test(slug),
                                        showSegmentList: true
                                    },
                                    () => this.fetchArhives()
                                );
                            }
                        }
                        if (parsedSearch && parsedSearch.search){
                            this.setState({ typeOfListing: 'search', showVideo: true});
                        }
                        if (!location.search && !slug && !match.params.slug) {
                            this.fetchArhives();
                        }
                    }
                );
            });
    }

    render() {
        const {
            arhives,
            typeOfListing,
            totalNumberOfEntries,
            entriesPerPage,
            currentPageNumber,
            listingId,
            listingTitle,
            anchors,
            vintage,
            segments,
            videoElement,
            showSegmentList,
            searchAnchorId,
            searchSegmentId,
            showVideo,
            programSegmentId,
            searchFullText
        } = this.state;

        const shouldRenderVideo =
            !(typeof videoElement === 'undefined' || videoElement === null) &&
            showVideo;

        const showPagination = totalNumberOfEntries > entriesPerPage;
        return (
            <div className="content">
                <ArchivesFilters
                    history={this.props.history}
                    typeOfListing={typeOfListing}
                    setTypeOfListing={this.setTypeOfListing}
                    setTypeOfListingForDate={this.setTypeOfListingForDate}
                    anchors={anchors}
                    vintage={vintage}
                    segments={segments}
                    slug={this.props.slug}
                    user={this.props.user}
                />
                {shouldRenderVideo && (
                    <ArchivesVideoPlayer
                        user={this.props.user}
                        videoElement={videoElement}
                        typeOfListing={typeOfListing}
                        showSegmentList={showSegmentList}
                        searchAnchorId={searchAnchorId}
                        searchSegmentId={searchSegmentId}
                        programSegmentId={programSegmentId}
                    />
                )}
                <ArchivesList
                    arhives={arhives}
                    typeOfListing={typeOfListing}
                    listingId={listingId}
                    listingTitle={listingTitle}
                    slug={this.state.vintageSlugPrefix}
                    searchFullText={searchFullText}
                />
                {showPagination && (
                    <Pagination
                        key={totalNumberOfEntries}
                        totalNumber={totalNumberOfEntries}
                        entriesPerPage={entriesPerPage}
                        activePageNumber={currentPageNumber * 1}
                        saveStateKeyParent={this.saveStateKey}
                    />
                )}
            </div>
        );
    }
}

export default Archives;
